(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eos-bracelet-story-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eos-bracelet-story-options')) {
    customElements.define('eos-bracelet-story-options', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const story = this.querySelector('[data-eos-story]');
        const details = this.querySelector('[data-eos-details]');
        if (!story || !details) return;
        this.ready = true;
        const marker = Array.from(story.querySelectorAll('p, h2, h3, h4, h5, h6, li, div')).find(element =>
          /^gift\s+ideas\s*:/i.test(element.textContent.trim()) &&
          !Array.from(element.children).some(child => /^(P|H[2-6]|LI|DIV)$/.test(child.tagName))
        );
        if (!marker) return;
        const range = document.createRange();
        range.setStartBefore(marker);
        range.setEnd(story, story.childNodes.length);
        details.append(range.extractContents());
        details.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eos-charm-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eos-charm-selector')) {
    customElements.define('eos-charm-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.select = this.querySelector('[data-eos-charm-choice]');
        this.variants = JSON.parse(this.querySelector('[data-eos-product-variants]').textContent);
        this.optionNames = JSON.parse(this.querySelector('[data-eos-product-options]').textContent);
        this.charmIndex = this.optionNames.findIndex(name => name.toLowerCase().includes('charm'));
        this.select.disabled = false;
        const initial = this.variants.find(v => String(v.id) === this.dataset.selectedId);
        if (this.charmIndex >= 0 && initial) {
          const oldChoice = initial.options[this.charmIndex].toLowerCase();
          const title = oldChoice.includes('gold') ? 'Angel wing (Gold)' : oldChoice.includes('silver') ? 'Angel wing (Silver)' : '';
          const choice = Array.from(this.select.options).find(o => o.dataset.title === title);
          if (choice) this.select.value = choice.value;
          const variantPicker = this.closest('section')?.querySelector('variant-radios, variant-selects');
          const components = variantPicker ? [customElements.whenDefined(variantPicker.localName)] : [];
          if (this.closest('section')?.querySelector('pickup-availability')) components.push(customElements.whenDefined('pickup-availability'));
          if (this.closest('section')?.querySelector('media-gallery')) components.push(customElements.whenDefined('media-gallery'));
          Promise.all(components).then(() => {
            const picker = this.closest('section')?.querySelector('variant-radios, variant-selects');
            const original = picker?.querySelector('[data-eos-original-charm]');
            if (original && initial.options[this.charmIndex] !== original.value) original.dispatchEvent(new Event('change', {bubbles: true}));
          });
        }
        this.onChange = () => this.updateTotal();
        this.select.addEventListener('change', this.onChange);
        this.variantInput = this.form.querySelector('[name="id"]');
        this.variantInput.addEventListener('change', this.onChange);
        this.updateTotal();
      }
      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onChange);
        this.variantInput?.removeEventListener('change', this.onChange);
        this.ready = false;
      }
      baseVariant(id) {
        const variant = this.variants.find(v => String(v.id) === String(id));
        if (!variant || this.charmIndex < 0) return variant;
        return this.variants.find(v => v.options.every((value, index) => index === this.charmIndex ? /without|no charm/i.test(value) : value === variant.options[index]));
      }
      updateTotal() {
        const output = this.querySelector('[data-eos-charm-total]');
        const base = this.baseVariant(this.form.querySelector('[name="id"]').value);
        const option = this.select.selectedOptions[0];
        output.hidden = !option?.value || !base;
        if (!output.hidden) {
          const price = (base.price + Number(option.dataset.price)) / 100;
          output.textContent = this.dataset.totalLabel + ' ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency}).format(price);
        }
      }
      prepare(data) {
        const base = this.baseVariant(data.get('id'));
        if (!base) throw new Error(this.dataset.sizeError);
        data.set('id', base.id);
        if (!this.select.value) return data;
        const quantity = Number(data.get('quantity') || 1);
        const group = crypto.randomUUID();
        const result = new FormData();
        result.set('items[0][id]', base.id);
        result.set('items[0][quantity]', quantity);
        for (const [key,value] of data.entries()) {
          if (key.startsWith('properties[')) result.append('items[0][' + key.replace('properties[','properties]['), value);
          if (key === 'selling_plan' && value) result.set('items[0][selling_plan]',value);
        }
        result.set('items[0][properties][_eos_charm_group]', group);
        result.set('items[1][id]', this.select.value);
        result.set('items[1][quantity]', quantity);
        result.set('items[1][parent_id]', base.id);
        result.set('items[1][properties][_eos_charm_group]', group);
        result.set('items[1][properties][_eos_charm_child]', 'true');
        const size = base.options.filter((value,index) => index !== this.charmIndex && value !== 'Default Title').join(' / ');
        result.set('items[1][properties][For bracelet]', this.dataset.productTitle + (size ? ' — ' + size : ''));
        return result;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
